/**
 * Part of the public contract: the marketer builds a MoEngage flow triggered
 * by this event, so renaming it breaks every existing customer's flow trigger.
 */
export const MOENGAGE_EVENT_NAME = "hightouch_interaction";

/**
 * MoEngage personalization reads an event attribute by a dotted path
 * (`{{EventAttribute['<event>.<attribute>']}}`), so a dot inside an attribute
 * name is ambiguous against a nested lookup, and the sync form asks for
 * snake_case.
 * https://help.moengage.com/hc/en-us/articles/115005552086-Personalization-in-Flows
 */
export function toMoengageAttributeKey(variableName: string): string {
  return variableName.toLowerCase().replace(/[^a-z0-9_]/g, "_");
}
